import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { SubmissionStatusFilter } from '../../exemption-portal/types';
import { TIndirectTaxCustomerGetSubmissionResponse } from './types';

export function useIndirectTaxSellerSubmissions(
  corporationId: number,
  status?: SubmissionStatusFilter | null
) {
  const query = new URLSearchParams();

  if (status) {
    query.append('status', status);
  }

  const { data, error, isLoading, mutate } = useSWR<
    TIndirectTaxCustomerGetSubmissionResponse[]
  >(
    corporationId
      ? `portal/sellers/${corporationId}/submissions?${query}`
      : null,
    SWRFetcher({ method: 'GET' }, undefined),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    submissions: data,
    isLoading,
    error,
    mutate,
  };
}
